import { useRef, useState } from 'react';
import { Tooltip } from 'react-tooltip';

export default function useCustomTooltip() {
  const [tooltipId, setTooltipId] = useState<string>('');
  const tooltipTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleShowToolTip = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const tooltipId = e.currentTarget.dataset.tooltipId || '';

    // Clear any existing timeout
    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
    }

    // need to control delay this way because delayShow and delayHide do not work when going from entry to entry
    tooltipTimeoutRef.current = setTimeout(() => {
      setTooltipId(tooltipId);
    }, 250);
  };

  const handleHideToolTip = () => {
    // Clear any pending timeout
    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
      tooltipTimeoutRef.current = null;
    }
    setTooltipId('');
  };

  return {
    customTooltip: (
      <Tooltip
        key={tooltipId}
        className='tooltip'
        id={tooltipId}
        style={{ zIndex: 100000 }}
        isOpen={!!tooltipId}
      />
    ),
    handleHideToolTip,
    handleShowToolTip
  };
}
